/**
 * Created by nguyendx on 2017/11/07
 * -------------------------------
 */

import {Component, Injector, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {EvsStoreService} from '../../../services/EvsStore.service';
import {UploadEvsService} from '../../../services/UploadEvs.service';

declare var $: any;

@Component({
    selector: 'store-upload-excel',
    templateUrl: './store.excel.component.html',
    styleUrls: ['./store.css'],
    providers: [EvsStoreService]
})

export class StoreExcelComponent implements OnInit {
    public product: any = {};
    public message: { class: string, content: string } = null;
    public titleFile: string = this.translate.instant("CHON_FILE_UPLOAD");
    public error: string = '';
    public files: any = null;

    constructor(public injector: Injector,
                public upload: UploadEvsService, private translate: TranslateService) {
    }

    ngOnInit() {
        console.log('aaaa');

    this.translate.onLangChange.subscribe(() => {
        if (!this.files || this.files.length === 0) {
            this.titleFile = this.translate.instant('CHON_FILE_UPLOAD');
        }
    });
    
    }

    onChange(event) {
        this.files = event.target.files;
        if (this.files.length > 0) {
            this.titleFile = this.files[0].name;
        } else {
            this.titleFile = this.translate.instant('CHON_FILE_UPLOAD');
        }
    }

    /*- checks if word exists in array -*/
    isInArray(array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    }
  clearInputFile(){
    var input = $("#controlFile");
    input.wrap('<form>').closest('form').get(0).reset();
    input.unwrap();
  }
    submitForm(data) {
        this.message = null;
        this.titleFile = this.translate.instant('CHON_FILE_UPLOAD');
        if (this.files !== null && this.files.length > 0) {
            var file = this.files[0];
            this.files = null;

            var file_name = file.name;
            var allowedExtensions = ["xlsx", "xls", "csv"];
            var fileExtension = file_name.split('.').pop();

            if (this.isInArray(allowedExtensions, fileExtension)) {
                //msg process
                this.message = {
                    class: "alert dark alert-success",
                    content: this.translate.instant('DANG_THUC_HIEN')
                };
                //upload file
                this.upload.upload(file).then((res: any) => {
                    // console.log('model upload: ', res);
                    if (!res.error) {
                        let number = res.data.ok;
                        if(number && number != null && number > 0 ){
                            this.message = {
                                class: "alert dark alert-icon alert-success",
                                content: this.translate.instant('SO_DIEM_BAN_THEM_THANH_CONG') + number
                            };
                        }
                        if(number == 0 || number == null){
                            this.message = {
                                class: "alert dark alert-icon alert-info",
                                content: this.translate.instant('KHONG_THANH_CONG_KIEM_TRA_DU_LIEU')
                            };
                        }

                    } else {
                        this.message = {
                            class: "alert dark alert-icon alert-danger",
                            content: res.message
                        }
                        ;
                    }
                }, error => {
                    this.message = {
                        class: "alert dark alert-icon alert-danger",
                        content: error.message
                    };
                });
            } else {
                this.message = {
                    class: "alert alert-danger",
                    content: this.translate.instant('VUI_LONG_CHON_DUNG_FILE_EXCEL')
                };
            }
        } else {
            this.message = {
                class: "alert alert-danger",
                content: this.translate.instant('BAN_CHUA_CHON_FILE_IMPORT')
            };
        }
      this.clearInputFile()

    }

}



// WEBPACK FOOTER //
// /app/src/app/common/helper/evs/store/store.excel.component.ts